import React from 'react';
import './index.scss';

const getPostStatus = post => {
  if (post.completed_at) return { key: 'completed', text: '已完成' };
  if (post.status === 'closed') return { key: 'closed', text: '已关闭' };
  if (post.status === 'expired' || (post.expire_time && new Date(post.expire_time).getTime() <= Date.now())) {
    return { key: 'expired', text: '已过期' };
  }
  const capacity = Number(post.max_participants ?? post.recruitment_count);
  if (capacity > 0 && Number(post.approved_participant_count) >= capacity) {
    return { key: 'full', text: '已满员' };
  }
  return post.is_recruiting
    ? { key: 'recruiting', text: '招募中' }
    : { key: 'paused', text: '暂不招募' };
};

const PostStatus = ({ post, className = '' }) => {
  const status = getPostStatus(post);
  return <span className={`post-status-badge is-${status.key} ${className}`}>{status.text}</span>;
};

export default PostStatus;
